import { PersonService } from '../../services/person.service';
import { SettingsService, TemplatesService } from "../../services/index";
import { TimezonesService } from "../../services/timezone.service";
import { StaffService } from "../../services/staff.service";
export const settingsState: aboTheme.IState = {

  parent: 'app',
  name: "settings",
  url: "/settings",
  component: 'settingsComponent',
  redirectTo: 'settings.company',
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'schedule'
    }
  }

};

export const settingsCompanyState: aboTheme.IState = {

  name: "settings.company",
  url: "/company",
  resolve: {
     company: (SettingsService: SettingsService) => { 'ngInject'; return SettingsService.customGet('CompanySettings'); }
  },
  views : {
      "main" : "settingsCompanyComponent"
  }

};

export const settingsEmployeeState: aboTheme.IState = {

  name: "settings.employees",
  url: "/employee",
  redirectTo: 'settings.employees.list'

};

export const settingsEmployeeListState: aboTheme.IState = {

  name: "settings.employees.list",
  url: "/list",
  resolve : {
    "employees" : (PersonService: PersonService) => { "ngInject"; return PersonService.all(); }
  },
  views : {
      "main@settings" : "employeeListComponent"
  }

};

export const settingsEmployeeItemState: aboTheme.IState = {

  name: "settings.employees.item",
  url: "/:id",
  resolve : {
    "employee" : (PersonService: PersonService, $stateParams: ng.ui.IStateParamsService) => { 
      "ngInject"; 
      return PersonService.get($stateParams['id']); }
  },
  views : {
      "main@settings" : "employeeItemComponent"
  }

};

export const settingsSalaryScaleState: aboTheme.IState = {

  name: "settings.salaryscales",
  url: "/salaryscales",
  resolve : {
    "salaryScales" : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('WageCodes'); }
  },
  views : {
    "main@settings" : "salaryScaleListComponent"
  }
};

export const settingsSalaryScaleEditState: aboTheme.IState = {

  name: "settings.salaryscales.edit",
  url: "/:id",
  modal: ['salaryScales'],
  resolve: {
  },
  component: 'salaryScalesDialogComponent'

};

export const templatesState: aboTheme.IState = {

  name: "settings.templates",
  url: "/templates",
  resolve: {
     templatesNames: (TemplatesService: TemplatesService) => { 'ngInject'; return TemplatesService.all(); }
  },
  views: {
    "main": "templatesEditorComponent"
  }

};

export const timezonesState: aboTheme.IState = {

  name: "settings.timezones",
  url: "/timezones",
  redirectTo: 'settings.timezones.list',
  views: {
    "main": "timezonesComponent"
  }

};

export const timezonesListState: aboTheme.IState = {

    name: "settings.timezones.list",
    url: "/list",
    resolve: { 
        timezones: (TimezonesService: TimezonesService) => { 'ngInject'; return TimezonesService.all(); }
    },
    views: {
        "main" : 'timezonesListComponent'
    }
};

export const timezonesItemState: aboTheme.IState = {

    name: "settings.timezones.list.item",
    url: "/:id",
    resolve: {
        timezone: (TimezonesService: TimezonesService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') {
          // console.log($stateParams['id']);
          return TimezonesService.get($stateParams['id']);
        } },
        hourCodes: (MasterdataService: aboMasterdata.IService) => {
          'ngInject';
          return MasterdataService.getItems('HourCodesAll');
        }
    },
    modal: ['timezone', 'hourCodes'],
    component: 'timezonesItemBasicComponent'
};

// export const timezonesItemBasicState: aboTheme.IState = {

//   name: "settings.timezones.list.basic",
//   url: "/:id",
//   modal: ['timezone', 'hourCodes'],
//   resolve: {
//   },
//   component: 'timezonesItemBasicComponent'

// };

export const staffState: aboTheme.IState = {

  name: "settings.staff",
  url: "/staff",
  redirectTo: 'settings.staff.list',
  views: {
    "main": "staffComponent"
  },
  data: {
    permissions: {
        only: ['SUPERUSER'],
        redirectTo: 'schedule'
    }
  }

};

export const staffListState: aboTheme.IState = {

  name: "settings.staff.list",
  url: "/list",
  resolve: { 
    staff: (StaffService: StaffService) => { 'ngInject'; return StaffService.all(); }
  },  
  views: {
    "main": "staffListComponent"
  }

};

export const staffItemState: aboTheme.IState = {

  name: "settings.staff.list.item",
  url: "/:id",
  // modal: [],
  resolve: {
      staff: (StaffService: StaffService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') {
        // console.log($stateParams['id']);
        return StaffService.get($stateParams['id']);
      } },
  },
  modal: [],
  component: 'staffItemComponent'
};


// WEBPACK FOOTER //
// ./src/app/modules/settings/settings.states.ts